function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { setHOCDisplayName } from '@domain-group/fe-helper';

/**
 * This React HOC gets the context and passes it on the specified component as a props.
 * This way the component is not directly using the context API.
 *
 * @param {Object} - The context types to be consumed by the specified component
 */
import { jsx as ___EmotionJSX } from "@emotion/core";
function consumeContext(contextTypes, wrapperName) {
  return BaseComponent => {
    var ContextConsumer = (props, context) => ___EmotionJSX(BaseComponent, _extends({}, props, context));
    ContextConsumer.contextTypes = contextTypes;
    setHOCDisplayName(ContextConsumer, BaseComponent, wrapperName || 'consumeContext');
    return ContextConsumer;
  };
}
export default consumeContext;